import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'

@Component({
  selector: 'ddc-button-n-one',
  templateUrl: './ddc-button-n-one.component.html',
  styleUrls: ['./ddc-button-n-one.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcButtonNOneComponent {
  @Input() _label: string
  @Input() _icon: string
  @Input() _color: string
  @Input() _dynamicRoute: string
  @Input() _hasBorder: boolean
  @Input() _selected: boolean
  @Input() _colorfulIcon: boolean = false
}
